export const GENRE_TAGS = [
  'Literary fiction', 'Romance', 'Sci-fi', 'Fantasy', 'Horror',
  'Historical fiction', 'Thriller & mystery', 'Short stories',
  'Graphic novel', 'Memoir & biography', 'Narrative nonfiction',
];

export const VIBE_TAGS = [
  'Sapphic', 'Queer', 'Own voices', 'BIPOC author', 'Feminist',
  'Translated', 'Debut novel', 'Award winner', 'Bestseller', 'Cult classic',
  'Slow burn', 'Found family', 'Dark academia', 'Cozy', 'Devastating',
  'Hopeful', 'Spiritual', 'Funny', 'Lyrical prose', 'Plot-driven', 'Character-driven',
  'Atmospheric', 'Unreliable narrator', 'Epistolary', 'Non-linear',
];

export const ALL_TAGS = [...GENRE_TAGS, ...VIBE_TAGS];
